import { getPropertyConfigBySlug } from '@mgmresorts/web-utils';
import { useEffect, useRef } from 'react';

import { useDerivedPropertySlug } from '../../hooks/useDerivedPropertySlug';

import { useAnalyticsService } from './analytics';

export function usePageLoadEvent(area: string, pageName: string) {
  const { trackSatellite, setDigitalData } = useAnalyticsService('page');
  const property = useDerivedPropertySlug();
  const propertyConfig = getPropertyConfigBySlug(property);
  const name = `${propertyConfig?.ticker || 'mgmr'}:${area}:${pageName}`;
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current && propertyConfig) {
      isFirstRender.current = false;
      setDigitalData('user', { loggedInStatus: false });
      setDigitalData('property', { id: propertyConfig?.id, name: propertyConfig?.websiteTitle });
      setDigitalData('page', { name, destinationUrl: window.location.href, language: 'en' });
      trackSatellite('pageLoader');
    }
  }, [name, property, setDigitalData, trackSatellite, propertyConfig, property]);
}
